import { Scan } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

export default function Introducing() {
    return (
        <section id="about" className="overflow-hidden bg-white py-24 md:py-36" data-testid="about-section">
            <div className="mx-auto max-w-[1320px] px-6 sm:px-10 lg:px-16">
                <div className="max-w-2xl">
                    <Reveal>
                        <Eyebrow>Introducing EDIT</Eyebrow>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h2 className="mt-7 text-5xl font-extralight leading-[1.04] tracking-[-0.03em] text-slate-950 sm:text-6xl lg:text-7xl">
                            Less searching.
                            <br />
                            <span className="italic font-light text-slate-950">More finding.</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.16}>
                        <p className="mt-9 max-w-lg text-lg font-extralight leading-relaxed text-slate-600" data-testid="about-support-text">
                            Meet EDIT. Your new fashion discovery platform. Find the pieces you love,
                            discover new brands and shop across retailers in one seamless experience.
                        </p>
                    </Reveal>
                    <Reveal delay={0.24}>
                        <div
                            className="mt-10 inline-flex items-center gap-3 rounded-full border border-slate-200 px-5 py-3"
                            data-testid="about-discovery-chip"
                        >
                            <Scan size={16} strokeWidth={1.5} className="text-slate-950" />
                            <span className="text-xs font-light tracking-[0.18em] text-slate-950">NEW DISCOVERY</span>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
